"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var connected_react_router_1 = require("connected-react-router");
var history_1 = __importDefault(require("../../common/Router/history"));
var seo_1 = __importDefault(require("./seo"));
var path_1 = __importDefault(require("./path"));
var filters_1 = __importDefault(require("./filters"));
var products_1 = __importDefault(require("./products"));
var pagination_1 = __importDefault(require("./pagination"));
var tags_1 = __importDefault(require("./tags"));
var breadcrumbs_1 = __importDefault(require("../../ItemApp/ducks/breadcrumbs"));
var buy_in_one_click_1 = __importDefault(require("../../ItemApp/ducks/buy-in-one-click"));
var product_1 = __importDefault(require("../../ItemApp/ducks/product"));
var itemSeo_1 = __importDefault(require("../../ItemApp/ducks/itemSeo"));
var location_data_1 = __importDefault(require("../../ItemApp/ducks/location-data"));
var reviews_1 = __importDefault(require("../../ItemApp/ducks/reviews"));
var url_1 = __importDefault(require("../../ItemApp/ducks/url"));
var cart_info_1 = __importDefault(require("../../ItemApp/ducks/cart-info"));
var is_admin_1 = __importDefault(require("../../ItemApp/ducks/is-admin"));
var licensee_store_1 = __importDefault(require("../../ItemApp/ducks/licensee-store"));
var ga4_1 = __importDefault(require("../../ItemApp/ducks/ga4"));
var rootReducer = (0, redux_1.combineReducers)({
    // common
    router: (0, connected_react_router_1.connectRouter)(history_1.default),
    buyInOneClick: buy_in_one_click_1.default,
    isMobile: function (state) {
        if (state === void 0) { state = false; }
        return state;
    },
    currency: function (state) {
        if (state === void 0) { state = {}; }
        return state;
    },
    onPlatform: function (state) {
        if (state === void 0) { state = null; }
        return state;
    },
    authenticityToken: function (state) {
        if (state === void 0) { state = ''; }
        return state;
    },
    path: path_1.default,
    // store
    seo: seo_1.default,
    filters: filters_1.default,
    products: products_1.default,
    pagination: pagination_1.default,
    tags: tags_1.default,
    isCustomStore: function (state) {
        if (state === void 0) { state = false; }
        return state;
    },
    ownDesignAllowed: function (state) {
        if (state === void 0) { state = false; }
        return state;
    },
    categories: function (state) {
        if (state === void 0) { state = []; }
        return state;
    },
    sort: function (state) {
        if (state === void 0) { state = []; }
        return state;
    },
    // item
    url: url_1.default,
    breadcrumbs: breadcrumbs_1.default,
    product: product_1.default,
    itemSeo: itemSeo_1.default,
    locationData: location_data_1.default,
    reviews: reviews_1.default,
    cartInfo: cart_info_1.default,
    isAdmin: is_admin_1.default,
    licenseeStore: licensee_store_1.default,
    ga4: ga4_1.default,
    // favorites
    isFavorites: function (state) {
        if (state === void 0) { state = false; }
        return state;
    },
});
// export type RootDispatch = ReturnType<typeof rootReducer>
exports.default = rootReducer;
